import { render, staticRenderFns } from "./SensorVirtualPeriodoTurno.vue?vue&type=template&id=6b0827cd&scoped=true&"
import script from "./SensorVirtualPeriodoTurno.vue?vue&type=script&lang=js&"
export * from "./SensorVirtualPeriodoTurno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0827cd",
  null
  
)

export default component.exports